import * as React from "react";
function SvgIcTableColumnTimeHidden(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.572 3.758L2.625 3H22v3.79H7.36l-.947-.758h14.633V3.758H3.572zM22.3 18.74v-8.167h-1.677V10h-1.072v.573h-4.836V10h-1.072v.573H12.09l1.31 1.048h7.825v1.234h-6.283l1.289 1.03h4.994v3.996l1.074.859zM2.187 3.648l20.457 16.366-.625.78-.618-.494H12v-7.521l-3-2.4v1.145H2v-3.79h3.694L4.513 6.79H2V4.78l-.438-.35m2.003 1.603l-.613-.491v.49h.613zm4.56 3.647l-1.247-.997H2.875v1.894h5.25V9.68zm11.962 9.57l-6.704-5.363h-.313v5.363h7.017zM2 17h7v-4H2v4zm6-3v2H3v-2h5zm-6 8h7v-4H2v4zm6-3v2H3v-2h5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnTimeHidden;
